import { BlankSlate, Box, Icon, TagColor } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import { Tabs } from 'modules/core/components/Table'
import type { TabType } from 'modules/core/components/Table'
import i18n from 'modules/core/lib/i18n'

import ComplaintIdAndActions from './ComplaintIdAndActions'
import type { TabIds } from './Tab'
import Tab from './Tab'
import { useComplaint } from './complaintContext'

interface Props {
  onDeleteComplaint: () => void
}

function Complaint({ onDeleteComplaint }: Props) {
  const { complaint, loading } = useComplaint()

  if (!complaint) {
    return (
      <Box height="full" justifyContent="center">
        <BlankSlate title={i18n.t('complaints.complaint.none_selected')} illustration="alert" />
      </Box>
    )
  }

  const activityLabel = (
    <Box flexDirection="row" gap="s4">
      {i18n.t('complaints.tabs.activity')}
      {!complaint.attributes.read_at && <Icon.Medium icon="bell" color="radicalRed1000" />}
    </Box>
  )

  const tabs: Array<TabType<TabIds>> = [
    {
      label: i18n.t('complaints.tabs.overview'),
      id: 'overview',
      color: TagColor.brand,
    },
    {
      // FIXME: This `activityLabel` type seems to be wrong because
      //        `label` is expecting a string.
      label: activityLabel as unknown as string,
      id: 'activity',
      color: TagColor.brand,
    },
  ]

  return (
    <Box gap="s40">
      <ComplaintIdAndActions complaint={complaint} />
      {loading && <Loading />}
      {!loading && (
        <Box>
          <Tabs marginLeft tabs={tabs}>
            {({ tab, isSelected }) => (
              <Tab
                tab={tab}
                borderTop
                isSelected={isSelected}
                key={tab.id}
                read={!!complaint.attributes.read_at}
                onDeleteComplaint={onDeleteComplaint}
              />
            )}
          </Tabs>
        </Box>
      )}
    </Box>
  )
}

export default observer(Complaint)
